import { Form, Select, DatePicker } from 'antd'
import { useLocation } from 'wouter';
import Button from '../../Atoms/Button/Button'
import InputFormContainer from '../../Atoms/InputFormContainer/InputFormContainer'
import SliderRangeCampaing from '../SliderRangeCampaing/SliderRangeCampaing';
import "./CampainsInboundFormSecond.scss";
const { Option } = Select;


const CampainsInboundFormSecond = ({ closeModalInboundSecond }) => {
  const [, setLocation ] = useLocation();
  const [form] = Form.useForm();

  const sendForm = (e) => {
    console.log(e); // Aqui el objeto con los valores del formulario
    closeModalInboundSecond()
    setLocation('/campaigns/gestionar')
  };

  const onChange = (e) => {
    console.log(e); 
  };
  
  return (
    <Form onFinish={sendForm} form={form} >
    <div className="nd-grid m-grid-2">
        <p className="source-24 m-cols-2 s-main-start mt-10 mb-20">Lista de perfiles</p>

        <InputFormContainer label="Fecha de inicio:" indentificador="initDate" >
          <Form.Item name="initDate" rules={[{required: true, message: "Debe indicar la fecha de inicio"}]}>
            <DatePicker size="large" placeholder="Fecha de inicio" onChange={onChange} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Hora de inicio:" indentificador="initHour">
          <Form.Item name="initHour" rules={[{required: true, message: "Debe indicar la hora de inicio"}]}>
            <input type="time" placeholder="Hora de inicio" />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Fecha de finalización:" indentificador="finalitationDate">
          <Form.Item name="finalitationDate" rules={[{required: true, message: "Debe indicar la fecha de finalización:"}]}>
            <DatePicker size="large" placeholder="Fecha de finalización" onChange={onChange} />
          </Form.Item>
        </InputFormContainer>

        <InputFormContainer label="Hora de finalización:" indentificador="finalitationHour">
          <Form.Item name="finalitationHour" rules={[{required: true, message: "Debe indicar la hora de finalización:"}]}>
            <input type="time" placeholder="Hora de inicio"  />
          </Form.Item>
        </InputFormContainer>

        <div className="m-cols-2">
          <InputFormContainer label="Frecuencia de la campaña:" indentificador="frecuence">
            <Form.Item name="frecuence" rules={[{required: true, message: "Frecuencia de la campaña:"}]}>
              <Select size="large" placeholder="Frecuencia de la campaña:">
                <Option value="Frecuencia de la campaña: ">Repetir diariamente</Option>
              </Select>
            </Form.Item>
          </InputFormContainer>
        </div>

        <p className="source-24 m-cols-2 s-main-start mt-20 mb-20">Cantidad de acciones por campaña:</p>
        
        <div className="m-cols-2 ">
          <SliderRangeCampaing />
        </div>
        
        <div className="buttons-container m-cols-2 mt-30">
          <Button content="Listo, crear campaña" customClass="s-large m-auto" type="primary" htmlType="submit" />
          <Button content="Ir al paso anterior" customClass="s-large m-auto" type="primary outline" />
        </div>
      </div>
    </Form>
  )
}

export default CampainsInboundFormSecond
